import type { CanDeactivateFn } from '@angular/router'

/** A screen that may hold unapplied attribute edits and asks before they are lost. */
export interface ConfirmsLeave {
  /**
   * Resolves true when the screen may be left for `nextUrl`: nothing unapplied,
   * or the Editor applied or discarded it; false to stay (Keep editing).
   */
  confirmLeave(nextUrl?: string): Promise<boolean> | boolean
}

/**
 * Segment editing's, Quick Edit's and Markup's leave guard (plan §4.3): any
 * in-app navigation away — the task list link, browser Back, a role switch —
 * first asks about unapplied attribute edits (Apply / Discard / Keep editing),
 * through each screen's `UnappliedChangesGate`. Quick Edit has no attribute
 * form, so it always resolves true.
 */
export const unappliedChangesGuard: CanDeactivateFn<ConfirmsLeave> =
  (component, _currentRoute, _currentState, nextState) => component.confirmLeave(nextState?.url)
